import { PayloadAction } from "@reduxjs/toolkit";

import { ApplicationState } from "../../types";

export const setShowOrderCardsModal = (
  state: ApplicationState,
  action: PayloadAction<boolean>
) => {
  state.showOrderCardsModal = action.payload;
}